<template>
  <div>
    <h1>Lista zamówień {{ serviceType }}</h1>

    <v-row>
      <v-col class="pr-2" md="3" cols="12">
        <v-text-field placeholder="Szukaj" v-model="search" />
      </v-col>
      <v-spacer />
      <v-col class="pl-2" md="6" cols="12">
        <v-combobox label="Status" multiple placeholder="Wszystkie" small-chips v-model="filterStatus" :items="singleServiceOrderStatus" />
      </v-col>
    </v-row>

    <v-data-table
      :loading="$store.getters['Ajax/loading'] ? 'accent' : false"
      :headers="headers"
      :items="filteredItems"
      class="table-less-padding"
      :sort-by.sync="pagination.sortBy"
      :sort-desc.sync="pagination.descending"
      :search="search"
      :custom-filter="filterOverAllProperty"
    >
      <template #item="props">
        <tr>
          <td>{{ props.item.company_name }}</td>
          <td>{{ props.item.created_by_name }}</td>
          <td>{{ props.item.created_at }}</td>
          <td>
            <span v-if="props.item.type === 'hotel'">
              {{ allRoomTypes().find(v => v.value === props.item.room_type).text }}
              <br />
              <b>{{ props.item.locationText }}</b>
            </span>
            <span v-if="props.item.type === 'flight'">
              Z <b>{{ props.item.startLocationText }}</b> do <b>{{ props.item.endLocationText }}</b> <br />
              Klasa:
              <b>{{ allFlightClassTypes().find(v => v.value === props.item.seat_class).text }}</b>
            </span>
            <span v-if="props.item.type === 'rail'">
              Z <b>{{ props.item.startLocationText }}</b> do <b>{{ props.item.endLocationText }}</b> <br />
              Klasa:
              <b>{{ allRailClassTypes().find(v => v.value === props.item.seat_class).text }}</b>
            </span>
            <span v-if="props.item.type === 'car'">
              Odbiór <b>{{ props.item.startLocationText }}</b>
              <span v-if="props.item.endLocationText != null && props.item.endLocationText.length > 0">
                zwrot <b>{{ props.item.endLocationText }}</b></span
              >
              <br />
              Klasa pojazdu:
              <b>{{ allCarTypes().find(v => v.value === props.item.car_class).text }}</b>
            </span>
            <span v-if="props.item.type === 'other'">
              Usługa: <b>{{ props.item.name }}</b>
            </span>
            <span v-if="props.item.type === 'insurance'">
              Ubezpieczenie: <br /><b
                >{{ props.item.start_date }} do {{ props.item.end_date }} <br />
                {{ props.item.locationText }}
              </b>
            </span>
            {{ props.item.comment }} <br />
            Dla:
            <span v-for="user in props.item.users" :key="user.passenger_id">
              <b>{{ user.name }} {{ user.surname }}</b
              >,
            </span>
            <template v-if="props.item.cost_centre !== null && props.item.cost_centre !== ''">
              <br />
              MPK: <b>{{ props.item.cost_centre }}</b>
            </template>
          </td>
          <td>
            <single-service-order-chip :status="props.item.status" :text="null" />
          </td>
          <td>
            {{ props.item.order_group_id }}
            <span v-for="responsePersonName in props.item.responsePerson" :key="responsePersonName" v-text="responsePersonName" />
          </td>
          <td class="text-no-wrap">
            <v-tooltip
              bottom
              v-if="[itemsStatus.STATUS_CREATED, itemsStatus.STATUS_READY_TO_SEND, itemsStatus.STATUS_ALREADY_SEND].includes(props.item.status)"
            >
              <template #activator="{on}">
                <v-btn :to="'/admin/travel-service/item/edit/' + props.item.id" icon v-on="on">
                  <v-icon>assignment</v-icon>
                </v-btn>
              </template>
              Zaofertuj zamówienie
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="
                [itemsStatus.STATUS_CANCELED_BY_CLIENT, itemsStatus.STATUS_BOOKING_CANCELLED, itemsStatus.STATUS_CLIENT_REQUEST_BOOKING_CANCEL].includes(
                  props.item.status
                )
              "
            >
              <template #activator="{on}">
                <v-btn :to="'/admin/travel-service/item/readonly/' + props.item.id" icon v-on="on">
                  <v-icon>assignment</v-icon>
                </v-btn>
              </template>
              Podgląd oferty
            </v-tooltip>
            <v-tooltip
              bottom
              v-if="
                [itemsStatus.STATUS_OFFER_ACCEPTED_BY_CLIENT, itemsStatus.STATUS_BOOKED, itemsStatus.STATUS_REQUEST_CLIENT_ANSWER_FOR_BOOK].includes(
                  props.item.status
                )
              "
            >
              <template #activator="{on}">
                <v-btn :to="'/admin/travel-service/add-booking/' + props.item.id" icon v-on="on">
                  <v-icon>assignment</v-icon>
                </v-btn>
              </template>
              Dołącz rezerwację
            </v-tooltip>

            <v-tooltip bottom>
              <template #activator="{on}">
                <v-btn :to="'/admin/travel-service/edit/' + props.item.order_service_id" icon v-on="on">
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>
              </template>
              Przejdź do szczegółów całości zamówienia
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { itemsStatus, serviceStatus, singleServiceOrderStatus } from "../../../staticData/ServiceOrder";
import SingleServiceOrderChip from "../../../components/TravelService/SingleServiceOrderChip";
import { allCarTypes, allFlightClassTypes, allRailClassTypes, allRoomTypes } from "../../../staticData/TravelServiceTypes";
import filterOverAllProperty from "../../../repository/filterOverAllProperty";

export default {
  name: "AdminTravelServiceByTypeView",
  components: { SingleServiceOrderChip },
  data: () => ({
    headers: [
      { text: "Firma", value: "type" },
      { text: "Zamawiający", value: "created_by_name" },
      { text: "Utworzono", value: "created_at" },
      { text: "Parametry", value: "param", sortable: false },
      { text: "Status", value: "status" },
      { text: "ID/Konsultant", value: "responsiblePerson" },
      { text: "", value: "actions" }
    ],
    pagination: { sortBy: "created_at", descending: true },
    items: [],
    filterStatus: [],
    search: null,
    itemsStatus: itemsStatus,
    serviceStatus: serviceStatus
  }),
  computed: {
    singleServiceOrderStatus: singleServiceOrderStatus,
    serviceType() {
      if (this.$route.params.type === "rail") return "kolejowych";
      if (this.$route.params.type === "flight") return "lotniczych";
      if (this.$route.params.type === "low-cost") return "tanich lini lotniczych";
      if (this.$route.params.type === "hotel") return "hotelowych";
      if (this.$route.params.type === "car") return " wynajmu samochodów";
      if (this.$route.params.type === "insurance") return " ubezpieczeń";
      if (this.$route.params.type === "other") return " niestandardowych";
      return "serviceTypeTODO";
    },
    filteredItems() {
      return this.items.filter(v => {
        if (this.filterStatus.length === 0) return true;
        for (let status of this.filterStatus) {
          if (v.status === status.value) return true;
        }
        return false;
      });
    }
  },
  watch: {
    serviceType() {
      this.downloadItems();
    }
  },
  methods: {
    downloadItems() {
      this.items = [];
      this.axios.get("/admin/travel-service-admin/get-service-order-items-list?type=" + this.$route.params.type).then(resp => {
        this.items = resp.data;
      });
    },
    allCarTypes,
    allFlightClassTypes,
    allRailClassTypes,
    allRoomTypes,
    filterOverAllProperty: filterOverAllProperty
  },
  beforeMount() {
    this.downloadItems();
  }
};
</script>

<style scoped />
